import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { TabPanel } from '../../helpers/TabPanel'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import walletPagesRoleManagement from '../../staticRoleManagement/walletRoleManagement'
import WalletDetail from '../WalletDetail'
import WalletInvoiceList from '../WalletInvoiceList'
import WalletSettlement from '../WalletSettlement'
import WalletTransactionHistory from '../WalletTransactionHistory'
import useStyles from './styles/index.styles'

export default function WalletDetailTabs() {
  const classes = useStyles()

  const theme = useTheme()
  const { pathname } = useLocation()
  const params = useParams<{ walletId: string }>()
  const [hasSettelment, setHasSettelment] = useState(false)
  const segments = pathname.split('/').filter(Boolean)

  const walletIndex = segments.indexOf(params.walletId)
  const page = segments[walletIndex + 1]

  const tabsList = [
    {
      value: 'details',
      className: classes.tab,
      label: getTranslate('Wallet Details'),
      component: LocalizedLink,
      to: `/adopay/wallet/${params.walletId}/details`
    },
    {
      value: 'settlement',
      className: classes.tab,
      label: getTranslate('Settlement'),
      component: LocalizedLink,
      to: `/adopay/wallet/${params.walletId}/settlement`
    },
    {
      value: 'invoice-list',
      className: classes.tab,
      label: getTranslate('Invoice List'),
      component: LocalizedLink,
      to: `/adopay/wallet/${params.walletId}/invoice-list`
    },
    {
      value: 'transaction-history',
      className: classes.tab,
      label: getTranslate('Transactions History'),
      component: LocalizedLink,
      to: `/adopay/wallet/${params.walletId}/transaction-history`
    }
  ]

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          // onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          // scrollButtons="on"
          // variant="scrollable"
          // scrollButtons="on"
        >
          {tabsList
            .filter((ele) => {
              if (hasSettelment) {
                return true
              } else {
                return (
                  ele.value !== 'settlement' && ele.value !== 'invoice-list'
                )
              }
            })
            .filter(() =>
              walletPagesRoleManagement
                .find(
                  (item) =>
                    item.route ===
                    '/adopay/wallet/:walletId/(details|settlement|invoice-list|transaction-history)/:status?'
                )
                ?.rolesListWithReadAccess?.includes(getRoleFromStorage())
            )
            .map((tabItem) => (
              <Tab
                key={tabItem.value}
                value={tabItem.value}
                className={tabItem.className}
                label={tabItem.label}
                to={tabItem.to}
                component={LocalizedLink}
              />
            ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="details"
        dir={theme.direction}
        className={classes.tabPanel}>
        <WalletDetail setHasSettelment={setHasSettelment} />
      </TabPanel>
      {hasSettelment && (
        <>
          <TabPanel
            value={page}
            index="settlement"
            dir={theme.direction}
            className={classes.tabPanel}>
            <WalletSettlement />
          </TabPanel>
          <TabPanel
            value={page}
            index="invoice-list"
            dir={theme.direction}
            className={classes.tabPanel}>
            <WalletInvoiceList />
          </TabPanel>
        </>
      )}
      <TabPanel
        value={page}
        index="transaction-history"
        dir={theme.direction}
        className={classes.tabPanel}>
        <WalletTransactionHistory />
      </TabPanel>
    </div>
  )
}
